import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "faq";

export const useFaqStore = defineStore(storeName, () => {
  const all = ref([]);
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);
  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("faq", errorCallback);
  };

  onMounted(async () => {
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    all,
    fetchAll,
  };
});
